
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 11c2.84 0 5.143-2.238 5.143-5S13.84 1 11 1C8.16 1 5.857 3.238 5.857 6S8.16 11 11 11zm3.6 1.25h-.671a7.17 7.17 0 01-5.858 0H7.4c-2.981 0-5.4 2.352-5.4 5.25v1.625C2 20.16 2.864 21 3.929 21H18.07C19.136 21 20 20.16 20 19.125V17.5c0-2.898-2.419-5.25-5.4-5.25z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_meu_perfil.svg